import { useEffect } from "react";

import AOS from "aos";
import { Link } from "react-router-dom";

const Investment = ({ handleView, isForHomePage }) => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);


  return (
    <div className="investment-header">
      <div className="header-center-container" data-aos="fade-up">
        <h1 style={{ "textAlign": "center" }}>
          Be financially smarter – rest while
          <br /> <span>your money</span> does the work
        </h1>
      </div>
      <p style={{ "textAlign": "center" }}>
        With our wealth management plans, you can take a trip to the Bahamas knowing without any iota of <br /> doubt that your money is in safe hands yielding returns for you. You have worked so hard for your <br /> money; with our tailored low-risk plans, watch your money return the favour
      </p>
      {
        !isForHomePage ?
          <>

            <div className="investment-header-btn button">
              <button onClick={handleView} className="btn btn-primary shadow-none">Get Started</button>
            </div>
            <div className="invest-img-container">
              <img
                className="invest-img"
                src={`${process.env.PUBLIC_URL}/assets/img/invest.png`}
                data-aos="flip-up"
                alt="buttom-img"
              />
            </div>
          </>
          :
          <div className="investment-header-btn button">
            <button  className="btn btn-primary shadow-none">
              <Link to={'/wealth-management'} className="text-white" style={{textDecoration:'none'}}>Checkout Our Investment Plans</Link>
            </button>
          </div>
      }
    </div>
  );
};

export default Investment;
